// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/Login';

import HomeLayout from './layout/HomeLayout';
import PaymentControlForm from "./components/PaymentControlForm";
import ControlDePagos from './components/ControlDePagos';
import PaymentControlsToAuthorize from './components/PaymentControlsToAuthorize';
import PaymentAuth from './components/PaymentAuth';
import AnadirMontoForm from './components/AnadirMontoForm';
import LayoutFiscal from './modules/Fiscal/LayoutFiscal';
import LayoutNoFiscal from './modules/NoFiscal/LayoutNoFiscal';
import TablaNoFiscal from './components/TablaNoFiscal';
import SettingsAuthForm from './components/SettingsAuthForm';
import ControlContratistas from './components/ControlContratistas';
import UsuarioLayout from './modules/Usuarios/layouts/UsuarioLayout';
import Relaciones from './components/Relaciones';
import ControlPresupuesto from './components/ControlPresupuesto';
import EstadoCuenta from './modules/EstadoCuenta/EstadoCuenta';
import PerfilLayout from './modules/Perfiles/layouts/PerfilLayout'
import QuincenasLayout from './modules/Quincenas/layouts/QuincenasLayout'
import FoliosLayout from './modules/Folios/FoliosLayout'

import ProtectedRoutes from './utils/ProtectedRoutes';
import { AuthProvider } from './contexts/AuthProvider';
import { FloatButton } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

// Botón flotante global de regresar (se oculta en login y selección de obra)
const BackFloatButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hidden = ['/', '/login', '/home'].includes(location.pathname);
  if (hidden) return null;

  const handleBack = () => {
    // Si la ruta tiene state con datos de obra, regresar a /home con la obra preseleccionada
    const obraState = location.state?.from;
    if (obraState && obraState.id) {
      navigate('/home', { state: { from: obraState } });
    } else {
      navigate(-1);
    }
  };

  return (
    <FloatButton
      icon={<ArrowLeftOutlined />}
      tooltip="Regresar"
      style={{ left: 24, bottom: 24 }}
      onClick={handleBack}
    />
  );
};

function App() {
  const [authToken, setAuthTokenState] = useState(localStorage.getItem('token') || null);

  const setAuthToken = (token) => {
    setAuthTokenState(token);
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              authToken ? <Navigate to="/home" /> : <Login setAuthToken={setAuthToken} />
            }
          />
          <Route path='*' element={<Login setAuthToken={setAuthToken} />} />
          <Route element={<ProtectedRoutes setAuthToken={setAuthToken} authToken={authToken} />}>
            <Route path='/home' element={<HomeLayout />} />
            <Route path='/payment-control' element={<PaymentControlForm />} />
            <Route path='/payment-control/:id' element={<PaymentControlForm />} />
            <Route path='/payment-control-list' element={<ControlDePagos />} />
            <Route path='/payment-control-toAuthorize' element={<PaymentControlsToAuthorize />} />
            <Route path='/add-amount' element={<AnadirMontoForm />} />
            <Route path='/fiscal' element={<LayoutFiscal />} />
            <Route path='/no-fiscal' element={<LayoutNoFiscal />} />
            <Route path='/settings-auth' element={<SettingsAuthForm />} />
            <Route path='/builders' element={<ControlContratistas />} />
            <Route path='/users' element={<UsuarioLayout />} />
            <Route path='/relationships' element={<Relaciones />} />
            <Route path='/budget-control' element={<ControlPresupuesto />} />
            <Route path='/statement' element={<EstadoCuenta />} />
            <Route path='/profiles' element={<PerfilLayout />} />
            <Route path='/quincenas' element={<QuincenasLayout />} />
            <Route path='/folios' element={<FoliosLayout />} />
          </Route>
          <Route path='/verify/:paymentAuth/:status/:authLevel' element={<PaymentAuth />} />
        </Routes>
        <BackFloatButton />
      </Router>
    </AuthProvider>
  );
}

export default App;

